var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "body-wrapper" },
    [
      _vm.event && _vm.dateSummary
        ? _c("div", { staticClass: "body-content" }, [
            _c("h1", [
              _c(
                "span",
                {
                  staticClass: "icon backbutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "eventSummary",
                        params: { id: _vm.event.id }
                      })
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-chevron-left" })]
              ),
              _vm._v(" " + _vm._s(_vm.event.title) + " ")
            ]),
            _vm.dateSummary && _vm.dateSummary.start
              ? _c("h3", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm
                          .moment(_vm.dateSummary.start.toDate())
                          .format("l h:mm a")
                      ) +
                      " "
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "level" }, [
              _c("p", { staticClass: "level-item" }, [
                _c("span", { staticClass: "total" }, [
                  _vm._v("Willcall: " + _vm._s(_vm.totalQty))
                ])
              ]),
              _c("p", { staticClass: "level-item" }, [
                _c("span", { staticClass: "total" }, [
                  _vm._v("Checkedin: " + _vm._s(_vm.totalCheckedin))
                ])
              ]),
              _c("p", [
                _c("span", { staticClass: "total" }, [
                  _vm._v(
                    "Total Sold: " +
                      _vm._s(_vm.dateSummary.totalSold) +
                      " / " +
                      _vm._s(_vm.dateSummary.capacity)
                  )
                ])
              ]),
              _c("p", { staticClass: "level-item has-text-centered" }, [
                _c(
                  "button",
                  { staticClass: "button", on: { click: _vm.addcomp } },
                  [_vm._v("Add Comp")]
                )
              ]),
              _c("p", { staticClass: "level-item has-text-centered" }, [
                _c(
                  "button",
                  { staticClass: "button", on: { click: _vm.walkup } },
                  [_vm._v("Walk Up")]
                )
              ]),
              _vm.event.festivalId
                ? _c("p", { staticClass: "level-item has-text-centered" }, [
                    _c(
                      "button",
                      { staticClass: "button", on: { click: _vm.pass } },
                      [_vm._v("Use Pass")]
                    )
                  ])
                : _vm._e(),
              _vm.event.festivalId
                ? _c("p", { staticClass: "level-item has-text-centered" }, [
                    _c(
                      "button",
                      { staticClass: "button", on: { click: _vm.newpass } },
                      [_vm._v("Add Pass")]
                    )
                  ])
                : _vm._e()
            ]),
            _c("h4", [_vm._v("Willcall")]),
            _c(
              "table",
              { attrs: { id: "eventTable" } },
              [
                _vm._m(0),
                _vm._l(_vm.willcall, function(audience) {
                  return _c("WillcallLine", {
                    key: audience.id,
                    attrs: {
                      audience: audience,
                      eventId: _vm.event.id,
                      dateId: _vm.dateSummary.dateId
                    },
                    on: {
                      move: function($event) {
                        return _vm.move(audience)
                      },
                      moveshow: function($event) {
                        return _vm.moveshow(audience)
                      },
                      showOrderDetails: _vm.showOrderDetails,
                      "show-cancel-modal": _vm.showCancelModal
                    }
                  })
                })
              ],
              2
            ),
            _c("div", { staticClass: "spacer" }),
            _c("h4", [_vm._v("Checked In")]),
            _c(
              "table",
              { attrs: { id: "eventTable" } },
              [
                _vm._m(1),
                _vm._l(_vm.checkedin, function(audience) {
                  return _c(
                    "tr",
                    {
                      key: "checkedin-" + audience.id,
                      staticClass: "clickable-row",
                      on: {
                        click: function($event) {
                          return _vm.showOrderDetails(audience)
                        }
                      }
                    },
                    [
                      _c("td", [_vm._v(_vm._s(audience.firstName))]),
                      _c("td", [_vm._v(_vm._s(audience.lastName))]),
                      _c("td", [_vm._v(_vm._s(audience.email))]),
                      _c("td", [_vm._v(_vm._s(audience.checkedin))]),
                      _c("td", [_vm._v(_vm._s(audience.tierName))]),
                      _c(
                        "td",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              on: {
                                click: function($event) {
                                  return _vm.undoCheckin(audience)
                                }
                              }
                            },
                            [_vm._v("Undo")]
                          )
                        ]
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _c("div", { staticClass: "spacer" }),
            _vm.cancelled && _vm.cancelled.length > 0
              ? _c("div", [
                  _c("h4", [_vm._v("Cancelled")]),
                  _c(
                    "table",
                    { attrs: { id: "eventTable" } },
                    [
                      _vm._m(2),
                      _vm._l(_vm.cancelled, function(audience) {
                        return _c(
                          "tr",
                          {
                            key: "cancelled-" + audience.id,
                            staticClass: "clickable-row",
                            on: {
                              click: function($event) {
                                return _vm.showOrderDetails(audience)
                              }
                            }
                          },
                          [
                            _c("td", [_vm._v(_vm._s(audience.firstName))]),
                            _c("td", [_vm._v(_vm._s(audience.lastName))]),
                            _c("td", [_vm._v(_vm._s(audience.email))]),
                            _c("td", [_vm._v(_vm._s(audience.cancelled))]),
                            _c("td", [_vm._v(_vm._s(audience.tierName))]),
                            _c(
                              "td",
                              {
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                  }
                                }
                              },
                              [
                                audience.status !== "refunded"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "button",
                                        on: {
                                          click: function($event) {
                                            return _vm.undoCheckin(audience)
                                          }
                                        }
                                      },
                                      [_vm._v(" Undo ")]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "refunded-label" },
                                      [_vm._v(" Refunded ")]
                                    )
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _c("CompDetailsModal", {
        attrs: {
          isVisible: _vm.showCompModal,
          comp: _vm.selectedComp,
          size: "large"
        },
        on: { close: _vm.closeCompModal }
      }),
      _c("CancelOrderModal", {
        attrs: {
          isVisible: _vm.showCancelModalDialog,
          order: _vm.selectedCancelOrder,
          event: _vm.event,
          venue: _vm.venue,
          eventId: _vm.eventId,
          dateId: _vm.id
        },
        on: { close: _vm.closeCancelModal, cancelled: _vm.onOrderCancelled }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", [_vm._v("First Name")]),
      _c("th", [_vm._v("Last Name")]),
      _c("th", { staticClass: "is-hidden-mobile" }, [_vm._v("email")]),
      _c("th", [_c("span", [_vm._v("Qty")])]),
      _c("th", { staticClass: "is-hidden-mobile" }, [_vm._v("Price Tier")]),
      _c("th")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", [_vm._v("First Name")]),
      _c("th", [_vm._v("Last Name")]),
      _c("th", [_vm._v("email")]),
      _c("th", [_vm._v("Quantity")]),
      _c("th", [_vm._v("Price Tier")]),
      _c("th")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", [_vm._v("First Name")]),
      _c("th", [_vm._v("Last Name")]),
      _c("th", [_vm._v("email")]),
      _c("th", [_vm._v("Quantity")]),
      _c("th", [_vm._v("Price Tier")]),
      _c("th")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }